import React from 'react';
import useGetPatientCartable from './hooks/useGetPatientCartable';
import { sortLatestExpireDate } from './functions/sortLatestExpireDate';
import CartableContainer from './components/CartableContainer';
import Cartable from './components/Cartable';
import { LinearProgress } from '@mui/material';

const PatientCartable = () => {
  const patientCartable = useGetPatientCartable();
  const latestExpireDateCartable =
    sortLatestExpireDate(patientCartable);

  console.log(
    'latestExpireDateCartable->',
    latestExpireDateCartable
  );

  return (
    <React.Fragment>
      <CartableContainer>
        {patientCartable === 'loading' ? (
          <LinearProgress />
        ) : (
          latestExpireDateCartable?.map((cartable) => (
            <Cartable
              key={cartable?.CodeForm}
              cartable={cartable}
            />
          ))
        )}
      </CartableContainer>
    </React.Fragment>
  );
};

export default PatientCartable;
